import { NavigationLink } from '../app/shared/interfaces/navigation-link';
import * as data from './departments.json';

export const departments: NavigationLink[] = (data as any).default
